import type { DashboardLayout, WeekModifier } from '../types'

export const DefaultCardLayout: DashboardLayout = {
    id: '00000000-0000-1000-8000-000000000000',
    version: 1,
    name: 'Dashboard',
    cards: [
        {
            id: '742b2b7f-8fdf-41a1-ac82-7b46fc6b9ac4',
            type: 'SalesThisWeek',
            width: 2,
            height: 1,
            config: {
                weekModifier: 0 as WeekModifier,
            },
            readOnly: true,
        },
        {
            id: '55a0c19d-4207-4608-9146-54265e50ae20',
            type: 'SalesLastWeek',
            width: 2,
            height: 1,
            config: {
                weekModifier: 1,
            },
            readOnly: true,
        },
        {
            id: '3e6a7a56-0115-4940-b667-84c1c1e43d50',
            type: 'RegisteredNextWeek',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: 'c7806bdf-dd45-4452-afd5-e4c30bf1da39',
            type: 'NewCustomersThisWeek',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: 'ff7a5618-7ccb-4bb8-a24f-bf963291f3b8',
            type: 'BiddersThisWeek',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: '5499eaf0-8224-4842-b0a2-bb798b49d722',
            type: 'VehiclesCheckedInCount',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: '6104493d-532b-4aee-96c8-bd147db3ba35',
            type: 'NeedPhotos',
            width: 1,
            config: {},
            height: 1,
            readOnly: true,
        },
        {
            id: 'cc562db9-d365-44dd-9c1d-cf1e93bde3ef',
            type: 'ConsignedVehicles',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: 'ae723b71-a34d-4646-aef7-5de7bc316d48',
            type: 'PipelineVehicleListings',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: 'd9f15f7c-8b3c-4848-9989-2fd6f92216b1',
            type: 'VDPViews',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: '6d988d84-820c-4a7b-9267-23271a44b575',
            type: 'WatchedVehicles',
            width: 1,
            height: 1,
            config: {},
            readOnly: true,
        },
        {
            id: '4fd77ff4-00fa-4b4a-8345-5d393de9ac4b',
            type: 'MyContactLogFollowups',
            width: 1,
            height: 1,
            config: {},
        },
        {
            id: '4fd77ff4-00fa-4b4a-8345-5d393de9ac4z',
            type: 'CompletedVehicles',
            width: 1,
            height: 1,
            config: {
                text: 'Vehicles',
                text2: 'Sold / Exited / Redeemed / Returned',
                secondaryText: 'Total',
            },
            readOnly: true,
        },
    ],
}

export const normalizeDashboard = (dashboard: string | null | undefined): DashboardLayout =>
    dashboard ? JSON.parse(dashboard) : DefaultCardLayout

export default normalizeDashboard
